// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".footer[data-v-10ad17b3]{background-color:#fff;border-top:1px solid #cccfd7;bottom:0;height:90px;left:0;padding:16px;position:fixed;width:100%;z-index:49}.footer__container[data-v-10ad17b3]{align-items:center;background-color:#fff;display:flex;height:100%;justify-content:space-around}.widthContent .footer__container[data-v-10ad17b3]{background-color:#f7f8fa;border-radius:50px;justify-content:space-between;padding:2px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
